/**
 * Student API Service
 * Handles all student-related API calls
 */

import apiClient from '../apiClient';
import { ENDPOINTS } from '../endpoints';

// ================== DASHBOARD ==================

/**
 * Get student dashboard data
 */
export const getStudentDashboard = () =>
  apiClient.get(ENDPOINTS.STUDENT.DASHBOARD);

/**
 * Get homework notifications for student
 */
export const getStudentHomeworkNotification = () =>
  apiClient.get(ENDPOINTS.STUDENT.HOMEWORK_NOTIFICATION);

/**
 * Get the most recently graded homework submissions for the student
 * across all of their groups. Used by the dashboard "Recent grades" panel.
 */
export const getStudentRecentGrades = (limit = 8) =>
  apiClient.get(ENDPOINTS.STUDENT.HOMEWORK_RECENT_GRADES, { params: { limit } });

// ================== GROUPS/SUBJECTS ==================

/**
 * Get student's subject/group list with pagination
 */
export const getStudentSubjectList = (searchText = '', page = 0, size = 10) =>
  apiClient.get(ENDPOINTS.STUDENT.GROUP, {
    params: {
      keyword: searchText,
      page,
      size
    }
  });

// ================== LESSONS ==================

/**
 * Get student's lesson schedule
 */
export const getStudentLessons = () =>
  apiClient.get(ENDPOINTS.STUDENT.LESSON);

// ================== HOMEWORK ==================

/**
 * Get homework for a specific group
 */
export const getStudentHomework = (groupId) =>
  apiClient.get(ENDPOINTS.STUDENT.HOMEWORK, {
    params: { 'group-id': groupId }
  });

/**
 * Upload homework submission
 */
export const uploadHomework = (taskId, homework) =>
  apiClient.post(`${ENDPOINTS.STUDENT.HOMEWORK}?task-id=${taskId}`, homework);

/**
 * Re-upload homework submission
 */
export const reUploadHomework = (homeworkId, taskId, homework) =>
  apiClient.patch(`${ENDPOINTS.STUDENT.HOMEWORK}/${homeworkId}?task-id=${taskId}`, homework);

